<template>
	<div class="page-header">
		<slot v-if="showBreadcrumbs === 'yes'"></slot>
		<div class="container">
			<h1 v-html="title"></h1>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		title: {
			type: String,
			default: 'Page Title',
		},
		showBreadcrumbs: {
			default: 'yes',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.page-header {
	background: $cpmec-blue;
	max-width: auto;
	// margin: 0 $spacer;

	.container {
		padding: $spacer * 3 $spacer;

		h1 {
			font-family: $font-family;
			font-style: normal;
			font-weight: normal;
			font-size: 60px;
			line-height: 70px;
			letter-spacing: 0;
			color: $cpmec-white;
			margin: 0;
			text-align: center;

			@media (max-width: $lg) {
				font-size: 50px;
				line-height: 50px;
				margin: 0;
			}
		}
	}

	#breadcrumbs {
		background-color: $cpmec-grey;

		a,
		span {
			color: white;
		}

		.colour-wrapper {
			background: rgba($cpmec-blue, 0.1);
			.container {
				padding: $spacer;

				span {
					&.divider {
						margin: 0 $spacer;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PageHeader.vue